let mobileMenu = document.getElementById('mobileMenu');
let mobileMenuBlur = document.getElementById('mobileMenuBlur');

//Open mobile menu
let btnMobileMenu = document.getElementById('btnToggleMobileMenu');
btnMobileMenu.addEventListener('click', function () {
  mobileMenu.classList.remove('fadeOut');
  mobileMenu.classList.remove('hidden');
  mobileMenu.classList.add('disp-block');
  mobileMenu.classList.add('fadeInDown');
  mobileMenuBlur.classList.add('disp-block');
  mobileMenuBlur.classList.add('fadeIn');
});

//show and hide sub products in mobile menu
let productsBTN = document.getElementById('productsBTN');
let subProducts = document.getElementById('subProducts');
let subProductsIsOpen = false;
productsBTN.addEventListener('click', function () {
  if (!subProductsIsOpen) {
    subProducts.classList.remove('hidden');
  } else {
    subProducts.classList.add('hidden');
  }
  subProductsIsOpen = !subProductsIsOpen;
});

//Close mobile menu
let btnCloseMobileMenu = document.getElementById('btnCloseMobileMenu');
btnCloseMobileMenu.addEventListener('click', function () {
  closeMobileMenu(mobileMenu);
});

mobileMenuBlur.addEventListener('click', function () {
  closeMobileMenu(mobileMenu);
});

function closeMobileMenu(mobileMenu) {
  mobileMenu.classList.remove('fadeInDown');
  mobileMenu.classList.remove('disp-block');
  mobileMenuBlur.classList.remove('fadeInDown');
  mobileMenuBlur.classList.remove('disp-block');
  mobileMenu.classList.add('fadeOut');
}
 function webengageLinkTracker (e) {
  let page = window.location.href;
  let action = e.target.href
  if (typeof webengage !== 'undefined') {
    webengage.track('click', {page, action})
  }
}
let s = document.getElementsByTagName('a');
for (let i = 0; i < s.length; i++) {
  s[i].onclick = webengageLinkTracker;
}


/**
 * Scroll page down to content
 */

window.scrollToSection = function (elementId) {
  let timerID = setInterval(function () {
    window.scrollBy(0, 30);
    let sliderHeight = document.getElementById(elementId).offsetTop - 30;
    if (window.pageYOffset >= sliderHeight || (sliderHeight + window.scrollY) >=
      document.body.offsetHeight)
      clearInterval(timerID);
  }, 30);
}



window.addEventListener("load", (event) => {

});

/**
 * *sticky menu
 */
const navbarAct ={
  hasRight:false,
  hasBanner:false,
  hasCampaign:false,
  isCampaignFixed:false,
}
document.addEventListener("DOMContentLoaded", (event) => {
  const navBarE = document.getElementById('navBar');
  const campaignE = document.getElementById('campaign');
  const borderLessE = document.getElementById('borderLess');
  if((!borderLessE || borderLessE.classList.contains('none')) && (!campaignE || campaignE.classList.contains('none'))){
    navbarAct.hasBanner = false;
  }
  else{
    navbarAct.hasBanner = true;
    navBarE.classList.add('aftBanner');

    if(campaignE && !campaignE.classList.contains('none')){
      navbarAct.hasCampaign = true;
      if(campaignE.classList.contains('fixed')){
        navbarAct.isCampaignFixed = true;
      }
    }
  }
});
window.addEventListener('scroll', function () {
  const navBarE = document.getElementById('navBar');
  const scrollTop = window.pageYOffset;
  if(navbarAct.hasCampaign && navbarAct.isCampaignFixed){
    if(scrollTop < 10 ){
      navbarAct.hasRight = false;
    }
    if(!navbarAct.hasRight){
      navbarAct.hasRight = true;
      const right = parseInt(window.getComputedStyle(navBarE).getPropertyValue('right'));
      navBarE.style.right = right+'px';
      window.setTimeout(()=>{
        navBarE.style.cssText = '';
      },1000)
    }
    else{
      window.setTimeout(()=>{
        navBarE.style.cssText = '';
      },1000)
    }
    if (scrollTop && scrollTop > 40) {
      navBarE.classList.add('sticky');
      navBarE.classList.add('fixedNext');
    } else {
      navBarE.classList.remove('sticky');
      navBarE.classList.remove('fixedNext');
    }
  }
  else{
    if(!navbarAct.hasBanner){
      if (scrollTop) {
        navBarE.classList.add('sticky')
      } else {
        navBarE.classList.remove('sticky');
      }
    }
    else{
      if (scrollTop && scrollTop > 40) {
        navBarE.classList.add('sticky')
        navBarE.classList.add('fixedFirst');
      } else {
        navBarE.classList.remove('sticky');
        navBarE.classList.remove('fixedFirst');
        navBarE.style.top = (56 - scrollTop)+'px';
      }
    }
  }
});


/**




 * clickoutside
 */
function clickOutside(targetElementId, callBack) {
  function clickOutSideHandler(evt) {
    const flyoutElement = document.getElementById(targetElementId);
    let targetElement = evt.target; // clicked element

    do {
      if (targetElement === flyoutElement) {
        return;
      }
      targetElement = targetElement.parentNode;
    } while (targetElement);
    // This is a click outside.
    document.removeEventListener('click', clickOutSideHandler);
    callBack();
  }

  setTimeout(() => {
    document.addEventListener('click', clickOutSideHandler);
  }, 50);
}

function showMoreMenu() {
  document.getElementById('moreMenu').classList.add('show');
}

function hideMoreMenu() {
  document.getElementById('moreMenu').classList.remove('show');
  document.getElementById('btnShowMoreMenu').addEventListener('click', btnShowMoreMenuHandler);
}

function btnShowMoreMenuHandler() {
  showMoreMenu();
  clickOutside('moreMenu', hideMoreMenu);
  document.getElementById('btnShowMoreMenu').removeEventListener('click', btnShowMoreMenuHandler);
}

hideMoreMenu();


// Get the modal
let modal = document.getElementById("myModal");

// Get the button that opens the modal
let btn = document.getElementById("myBtn");

// Get the <span> element that closes the modal
let span = document.getElementsByClassName("close")[0];

// When the user clicks the button, open the modal
if(btn){
  btn.onclick = function() {
    modal.style.display = "block";
  }
}


// When the user clicks on <span> (x), close the modal
if(span){
  span.onclick = function() {
    modal.style.display = "none";
  }
}

// When the user clicks anywhere outside of the modal, close it
window.onclick = function(event) {
  if (event.target == modal) {
    modal.style.display = "none";
  }
}
